import { render, staticRenderFns } from "./DoughChart.vue?vue&type=template&id=a073b816"
import script from "./DoughChart.vue?vue&type=script&lang=js"
export * from "./DoughChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports